<div [ngClass]="getTableClasses()">
  @if(tableData?.length){ @if(showHeading){
  <div class="dark:text-purple-300 px-6 text-purple-700 py-3 bg-transparent backdrop-blur-3xl w-full sticky top-0 z-20">
    Data Table
    <p class="dark:text-slate-400 text-slate-700 text-sm">
      Display data in tabular formats
    </p>
  </div>
  }
  <div [ngClass]="[
      getTableBorderRadiusClasses(),
      'overflow-auto w-full flex-1 scrollbar-theme scrollbar-hidden'
    ]" [style.maxHeight]="maxHeight">
    <table class="w-full" [ngClass]="tableClass">
      <thead [ngClass]="headerTopPosition" class="sticky z-10">
        @if(headers){
        <tr
          class="border-b border-[#EAEAEA] dark:border-line w-full">
          <!-- Checkbox Column Header -->
          @if(isCheckboxShow){
          <th [ngClass]="['py-3 px-4 text-left w-12', getTableHeadingClasses()]">
            <div class="flex items-center justify-center">
              <input type="checkbox" [checked]="isAllSelected()" [indeterminate]="isSomeSelected()"
                (change)="toggleAllRows($event)"
                class="w-4 h-4 rounded cursor-pointer transition-all duration-150 hover:scale-110"
                aria-label="Select all rows" />
            </div>
          </th>
          } @for(h of headers; track $index){
          <ng-container>
            @if(!h.isPrevious || previousData?.length){
            <th [ngClass]="[
                h.align || 'text-left',
                h.colClass || '',
                getTableHeadingClasses(),
                'py-3 px-4 font-normal dark:text-ink-muted text-[#7D7D93] text-sm tracking-wide transition-colors duration-200 cursor-pointer hover:bg-purple-50/30 dark:hover:bg-slate-700/30',
                h.colClass ? '' : 'max-w-[200px]'
              ]" (click)="sortData(tableData || [], h.label, tableKey)">
              <div class="flex items-center gap-1.5 flex-wrap" [ngClass]="{
                  'justify-start': h.align === 'text-left',
                  'justify-center': h.align === 'text-center',
                  'justify-end': h.align === 'text-right'
                }">
                <span [ngClass]="{ 'flex-col': isColFlex, 'flex-wrap': !isColFlex }"
                  class="leading-tight break-words flex items-center gap-1">
                  @if(h?.icon && showHeaderIcon){
                  <span class="text-center">
                    <app-icon-v2 [size]="16" [name]="h?.icon! || ''"></app-icon-v2>
                  </span>
                  }
                  {{ h.label }}
                  @if(!h.isPrevious && h.showProgress && previousData?.length){
                  <span
                    class="inline-flex items-center rounded-full border text-[10px] px-2 py-0.5 font-semibold shadow-sm transition-all duration-200 hover:scale-105 leading-none whitespace-nowrap flex-shrink-0"
                    [ngClass]="{
                      'bg-gradient-to-r from-emerald-50 to-emerald-100 text-emerald-700 border-emerald-200 dark:from-emerald-900/30 dark:to-emerald-800/30 dark:text-emerald-400 dark:border-emerald-700':
                        finalValue.type === 'Profit',
                      'bg-gradient-to-r from-red-50 to-red-100 text-red-700 border-red-200 dark:from-red-900/30 dark:to-red-800/30 dark:text-red-400 dark:border-red-700':
                        finalValue.type === 'Loss',
                      'bg-gradient-to-r from-gray-50 to-gray-100 text-gray-600 border-gray-200 dark:from-gray-800/30 dark:to-gray-700/30 dark:text-gray-400 dark:border-gray-600':
                        finalValue.type === 'No Profit No Loss'
                    }">
                    <!-- <span class="mr-0.5 text-[11px] font-bold">{{ finalValue.type === 'Profit' ? '↑' : finalValue.type === 'Loss' ? '↓' : '=' }}</span> -->
                    <span class="font-medium">{{ finalValue.percent }}%</span>
                  </span>
                  }
                </span>

                @if (sortState && sortState[tableKey] && sortState[tableKey].key){
                @if(sortState[tableKey].key.toLowerCase() === h.label.toLowerCase()){
                <!-- *ngIf="sortState[tableKey]?.key?.toLowerCase() === h.label.toLowerCase()" -->
                <span class="ml-1 flex items-center">
                  @if(sortState[tableKey].order === 'asc'){
                  <!-- *ngIf="sortState[tableKey]?.order === 'asc'" -->
                  <app-icon-v2 [size]='20' [name]="'arrowUp'" [class]="'w-4 h-4 text-purple-600'"></app-icon-v2>
                  }
                  @if(sortState[tableKey].order === 'desc'){
                  <!-- *ngIf="sortState[tableKey]?.order === 'desc'" -->
                  <app-icon-v2 [size]='20' [name]="'arrowDown'" [class]="'w-4 h-4 text-purple-600'"></app-icon-v2>
                  }
                </span>
                }
                }
              </div>
            </th>
            }
          </ng-container>
          }
        </tr>
        }
      </thead>

      <tbody class="">
        @for(row of tableData; track $index; let i = $index){
        <!-- transition-all duration-150 hover:bg-linear-to-r hover:from-[#F2F7FF] hover:to-[#FAFCFF] hover:shadow-sm cursor-pointer group -->
        <tr
          class="border-b last:border-b-0 transition-colors duration-200 dark:border-line border-[#EAEAEA] hover:bg-[#f5f5f5] dark:hover:bg-slate-800/30"
          [class.animate-fadeIn]="true" [style.animation-delay]="i * 50 + 'ms'">
          <!-- Checkbox Column Cell -->
          @if(isCheckboxShow){
          <td class="py-3 px-4 w-12">
            <div class="flex items-center justify-center">
              <input type="checkbox" [checked]="isRowSelected(row)" (change)="toggleRowSelection(row, $event)"
                (click)="$event.stopPropagation()"
                class="w-4 h-4 rounded cursor-pointer transition-all duration-150 hover:scale-110"
                [attr.aria-label]="'Select row ' + (i + 1)" />
            </div>
          </td>
          } @for(h of headers; track $index){
          <ng-container>
            @if(!h.isPrevious || previousData?.length){
            <td [ngClass]="[h.align || 'text-left', h.textClass || '', h.colClass || '']"
              class="py-3 px-4 break-words dark:text-ink-soft text-[#38385B] font-normal transition-colors duration-150">
              @switch (h.key) { @case ('action') {
              <!-- === ACTION CELL === -->
              <div (click)="toggleView(row)"
                class="inline-flex items-center gap-1 text-[#0066CC] hover:text-[#0052A3] font-semibold transition-colors duration-150 cursor-pointer">
                @if (h.showActionTooltip) {
                  <app-tooltip [content]="h.actionTooltip || ''" [position]="'left'" [flexCenter]="true" [className]="'min-w-28 !font-semibold !text-xs !px-3 !py-1.5 !rounded-md whitespace-nowrap'">
                    @if (row.actionIconV2) {
                      <app-icon-v2 [name]="row.actionIconV2" [customClass]="row.actionIconClass || ''" />
                    } @else {
                      <div [innerHTML]="row[h.key]"></div>
                    }
                  </app-tooltip>
                } @else {
                  @if (row.actionIconV2) {
                    <app-icon-v2 [name]="row.actionIconV2" [customClass]="row.actionIconClass || ''" />
                  } @else {
                    <div [innerHTML]="row[h.key]"></div>
                  }
                }
              </div>
              } @case ('urgentPayments') {
              <!-- === URGENT BADGE CELL === -->
              @if (row.urgentCount > 0) {
              <div
                class="flex items-center gap-1.5 rounded-[8px] bg-[#f6eeff] px-2 py-1 text-[12px] font-medium text-[#ad46ff] dark:bg-purple-800 dark:text-white w-fit">
                <app-icon-v2 name="zap" [size]="12" />
                {{ row.urgentCount }} Urgent
              </div>
              } @else {
              <span class="text-[15px] font-medium text-[#797f87] dark:text-ink-muted">0</span>
              }
              } @default {
              <!-- === NORMAL CELL === -->
              <div [ngClass]="{
                  'flex gap-2 items-center justify-start':
                    row.icon && h.showIcon
                }">
                @if (row.icon && h.showIcon) {
                <div
                  [ngClass]="['flex h-9 w-9 shrink-0 items-center justify-center rounded-lg', row.iconBgClass || 'bg-gray-50']">
                  <app-icon-v2 [size]="20" [name]="row.icon" [customClass]="row.iconClass || ''" />
                </div>
                }
                <p [ngClass]="{
                    'justify-start': h.align === 'text-left',
                    'justify-center': h.align === 'text-center',
                    'justify-end': h.align === 'text-right'
                  }" class="mb-0 flex items-center text-sm gap-1">
                  @if (h.renderAsHtml) {
                  <span
                    [innerHTML]="
                      getValue(
                        h.key,
                        resolveRow(h, row, i),
                        i,
                        h.transform,
                        h.noTransform,
                        h.dateFormat
                      )
                    "
                  ></span>
                  } @else {
                  <span [class.cursor-help]="h.showTooltip" (mouseover)="
                      h.showTooltip
                        ? onCellMouseOver($event, h, resolveRow(h, row, i))
                        : null
                    " (mouseleave)="h.showTooltip ? onCellMouseLeave() : null"
                    (mousemove)="h.showTooltip ? onCellMouseMove($event) : null">
                    {{
                    h.key === "index"
                    ? i + 1 + "."
                    : getValue(
                    h.key,
                    resolveRow(h, row, i),
                    i,
                    h.transform,
                    h.noTransform,
                    h.dateFormat
                    )
                    }}
                  </span>
                  }
                  @if (row?.showInlineProgress && (row[h?.key ?? ''] >= 0 ||
                  (previousData?.length && previousData?.[i][h?.key ?? ''] >=
                  0)) && !h?.isPrevious) {
                  <ng-container>
                    @for (progress of getProgressForRow(row, $safeNavigationMigration(previousData?.[i]),
                    h.key); track $index) { @if (progress.amount != 0) {
                    <span
                      class="inline-flex items-center text-xs font-bold px-1.5 py-0.5 rounded transition-all duration-150 hover:scale-105"
                      [ngClass]="{
                        'text-red-700 bg-red-50/80 dark:text-red-300 dark:bg-red-900/40 border border-red-200/50 dark:border-red-800/50':
                          progress.type == 'Loss',
                        'text-emerald-700 bg-emerald-50/80 dark:text-emerald-300 dark:bg-emerald-900/40 border border-emerald-200/50 dark:border-emerald-800/50':
                          progress.type != 'Loss'
                      }">
                      <span class="mr-0.5">{{
                        progress.type == "Loss" ? "↓" : "↑"
                        }}</span>
                      {{ progress?.percent }}%
                    </span>
                    } }
                  </ng-container>
                  }
                </p>
              </div>
              } }
            </td>
            }
          </ng-container>
          }
        </tr>
        }
      </tbody>
    </table>
  </div>

  } @else {
  <!-- Empty State -->
  <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
    <app-icon-v2 name="inbox" [size]="64" class="text-gray-300 mb-4"></app-icon-v2>
    <p class="text-lg font-medium">No data available</p>
    <p class="text-sm mt-1">Data will appear here when available</p>
  </div>
  }

  <!-- Enhanced Tooltip -->
  <div #tableTooltip
    class="table-tooltip absolute hidden bg-[#272D35] text-white rounded-lg p-3 shadow-xl max-w-xs transition-opacity duration-200 border border-gray-600"
    [innerHTML]="tooltipHTML" style="pointer-events: none"></div>
</div>